import React, { useEffect, useState } from 'react'
import Navbar from '../common/navbar'
import { Paper } from '@mui/material'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EventIcon from '@mui/icons-material/Event';
import Footer from '../common/footer';
import api from '../../API/api';
import { Navigate } from 'react-router-dom';

function SingleEvent() {

    const { state } = useLocation();

    // console.log("lllll", state);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const [event, setEvent] = useState(state)
    const [events, setEvents] = useState();

    // console.log(state, 'data');
    function handleChange(data) {
        setEvent(data)
    }

    const getEventAndNotice = () => {
        let current = new Date();
        api.getEventAndNotice().then((res) => {
            // setEvents(res.data.events)
            let newNotice = res.data.events.filter(obj => {
                let evntDate = new Date(obj.date)
                if (evntDate > current.getTime()) {
                    return obj;
                }
                return;
            })
            setEvents(newNotice);
        })
    }

    useEffect(() => {
        getEventAndNotice();
    }, [])

    return (
        <>
            <Navbar />
            <div className='envtSingl p-3'>
                {/* <Paper > */}
                <div className='row'>
                    <div className='col-md-8'>
                        <Paper elevation={3} className='p-3'>
                            <div className='evntSingle px-md-4'>
                                <div className='evnt-title'>
                                    <h3> {event?.event}</h3>
                                </div>
                                <div className='d-flex py-3'>
                                    {event?.school &&
                                        <div className='bg-lcoation me-2 '>
                                            <LocationOnIcon style={{ fontSize: 18 }} />
                                            <small className=''>
                                                {/* {event.school ? event.school : event.location} */}
                                                {event.location ? event.location : event.school}
                                            </small>
                                        </div>
                                    }
                                    {
                                        event?.date &&
                                        <div className='nowrap'>
                                            <div className='bg-lcoation p-1'>
                                                <EventIcon style={{ fontSize: 18 }} />
                                                {new Date(event.date).toDateString().slice(4, 20)}
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className='evntImage'>
                                    <img   className='img-fluid' src={`${process.env.REACT_APP_BACKEND}assets/events/img/${event?.image}`} alt='pews events'   />
                                </div>
                                <div className='evntDetails'>
                                    <div dangerouslySetInnerHTML={{ __html: event?.details }} />
                                </div>
                            </div>
                        </Paper>
                    </div>
                    <div className='col-md-4'>

                        <Paper elevation={3} className='p-3'>
                            <div>
                                <h4>Upcoming Events</h4>
                            </div>
                            <div className="row">
                                {events && events.map((ev) =>
                                (
                                    <div className="col-md-12 p-2">
                                        <Paper elevation={1} sx={{
                                            ':hover': {
                                                boxShadow: 10,
                                            },
                                        }} className='event-box p-2'>
                                            <a onClick={() => handleChange(ev)} href="javascript:void(0)" className='text-dec-none'>
                                                <div className='p-2'>
                                                    <div>
                                                        <h6 style={{ overflow: 'hidden' }}>
                                                            <Link to='/singleEvent' state={ev}><strong> {ev.event}</strong></Link>
                                                        </h6>
                                                    </div>
                                                    <div className='row align-item-center '>
                                                        <div className='col-md-8'>
                                                            {ev.school &&
                                                                <div className='bg-lcoation'>
                                                                    <LocationOnIcon style={{ fontSize: 18 }} />
                                                                    <small className=''>
                                                                        {ev.location ? ev.location : ev.school}
                                                                    </small>
                                                                </div>
                                                            }
                                                        </div>
                                                        {
                                                            ev.date &&
                                                            <div className='col-md-4 nowrap'>
                                                                <div className='bg-lcoation p-1'>
                                                                    <EventIcon style={{ fontSize: 18 }} />
                                                                    {new Date(ev.date).toDateString().slice(4, 20)}
                                                                </div>

                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </a>
                                        </Paper>
                                    </div>
                                ))}
                            </div>
                        </Paper>
                    </div>
                </div>
                {/* </Paper> */}
            </div>
            <Footer />
        </>
    )
}

export default SingleEvent;